<div class="org-dropdown-wrapper">

  <!-- Trigger: a field — 50px pill, chips for the picked levels -->
  <div class="org-dropdown-trigger"
       role="combobox"
       tabindex="0"
       aria-haspopup="tree"
       [attr.aria-controls]="panelId"
       [attr.aria-expanded]="isOpen()"
       [attr.aria-label]="placeholder() | translate"
       [class.is-open]="isOpen()"
       [class.has-value]="selections().length > 0"
       (click)="togglePanel($event)"
       (keydown.enter)="onTriggerKey($event)"
       (keydown.space)="onTriggerKey($event)">

    <div class="trigger-content">
      @if (selections().length === 0) {
        <span class="trigger-placeholder">{{ placeholder() | translate }}</span>
      } @else {
        <div class="trigger-tags">
          @for (sel of selections(); track sel.levelUuid) {
            <cm-ui-chip
              [label]="sel.chartName"
              [detail]="sel.levelName"
              removable
              [removeLabel]="'common.remove' | translate"
              (removed)="removeSelection(sel.levelUuid)" />
          }
        </div>
      }
    </div>

    <mat-icon class="trigger-arrow" [class.open]="isOpen()">expand_more</mat-icon>
  </div>

  <!-- Panel: the field's listbox -->
  @if (isOpen()) {
    <div class="org-dropdown-panel" [id]="panelId" [class.opens-above]="openAbove()" (click)="$event.stopPropagation()">

      @if (loading()) {
        <div class="panel-loading">
          <cm-ui-loader />
        </div>
      } @else if (charts().length === 0) {
        <cm-ui-empty-state message="ADMIN.orgStructureDropdown.noCharts" />
      } @else {
        <div class="chart-list">
          @for (chart of charts(); track chart.orgChartUuid) {
            <div class="chart-section">

              <div class="chart-header"
                   role="button"
                   tabindex="0"
                   [attr.aria-expanded]="isChartExpanded(chart.orgChartUuid!)"
                   (click)="toggleChartExpand(chart.orgChartUuid!)"
                   (keydown.enter)="toggleChartExpand(chart.orgChartUuid!)"
                   (keydown.space)="$event.preventDefault(); toggleChartExpand(chart.orgChartUuid!)">
                <mat-icon class="expand-icon" [class.expanded]="isChartExpanded(chart.orgChartUuid!)">
                  chevron_right
                </mat-icon>
                <mat-icon class="chart-icon">account_tree</mat-icon>
                <span class="chart-label">{{ chart.name }}</span>
              </div>

              @if (isChartExpanded(chart.orgChartUuid!)) {
                <div class="chart-body">
                  @if (isTreeLoading(chart.orgChartUuid!)) {
                    <cm-ui-loader />
                  }
                  @if (getChartTree(chart.orgChartUuid!); as root) {
                    <div class="chart-tree">
                      <ng-container
                        *ngTemplateOutlet="nodeTemplate; context: {
                          node: root,
                          chartUuid: chart.orgChartUuid,
                          chartName: chart.name,
                          depth: 0
                        }">
                      </ng-container>
                    </div>
                  } @else if (!isTreeLoading(chart.orgChartUuid!)) {
                    <cm-ui-empty-state message="ADMIN.orgStructureDropdown.noLevels" />
                  }
                </div>
              }

            </div>
          }
        </div>

        @if (selections().length > 0) {
          <div class="panel-footer">
            <cm-ui-standard-button rounded icon="close" (onClick)="clearAll()">
              {{ 'ADMIN.orgStructureDropdown.clearAll' | translate }}
            </cm-ui-standard-button>
          </div>
        }
      }

      <ng-template #nodeTemplate
                   let-node="node"
                   let-chartUuid="chartUuid"
                   let-chartName="chartName"
                   let-depth="depth">
        <div class="tree-node" [class.is-selected]="isLevelSelected(node.orgLevelUuid)">
          <div class="node-row" [style.padding-left.px]="depth * 20 + 8">
            <mat-checkbox
              [checked]="isLevelSelected(node.orgLevelUuid)"
              (change)="toggleLevel(node, chartUuid, chartName)"
              (click)="$event.stopPropagation()">
              <span class="node-name">{{ node.name }}</span>
            </mat-checkbox>
            @if (node.levelType) {
              <cm-ui-chip size="sm" [label]="getLevelTypeLabel(node.levelType)" />
            }
          </div>
        </div>

        @if (node.children && node.children.length > 0) {
          @for (child of node.children; track child.orgLevelUuid) {
            <ng-container
              *ngTemplateOutlet="nodeTemplate; context: {
                node: child,
                chartUuid: chartUuid,
                chartName: chartName,
                depth: depth + 1
              }">
            </ng-container>
          }
        }
      </ng-template>

    </div>
  }

</div>
